<div class="card bg-transparent border-0 shadow mt-3 p-4">
  <div class="card border-0 shadow-sm">
    @if ((type!='all')) {
      <div class="card-body">
        <label class="btn btn-default btn-sm text-center btn-file p-4 py-2 border-{{colorMapping[type]}} w-100" style="border: 2px dotted;">
          <i class="fa fa-cloud-upload fa-3x text-{{colorMapping[type]}}"></i>
          <input type="file" style="display: none;" (change)="uploadFiles($event)" #inputFile multiple>
        </label>
      </div>
    }
    @if (isLoading) {
      <div class="d-flex justify-content-center">
        <mat-progress-bar mode="indeterminate" aria-label="Loading records"></mat-progress-bar>
      </div>
    }
    <div class="card-body" [hidden]="!(data.length > 0)">
      <div class="table-responsive admin-content">
        <table class="table table-stripped">
          <thead class="table-light">
            <tr>
              <th scope="col" class="col-6 border-0">File Name</th>
              <th scope="col" class="border-0">Date Uploaded</th>
              <th scope="col" class="border-0">Actions</th>
              <th scope="col" class="border-0">Status</th>
            </tr>
          </thead>
          <tbody>
            @for (row of data | slice:pagination.offset:(pagination.offset+pagination.limit); track row) {
              <tr>
                <td style="cursor: default;" class="filename-cell">
                  <span [matTooltip]="row.displayName"
                    matTooltipPosition="above" class="filename-text">
                    {{ row.displayName }}
                  </span>
                </td>
                <td style="cursor: default;">
                  {{row.uploadedDate | date: 'MM/dd/yyyy h:mm a' : '' : 'en-US'}}
                </td>
                <td>
                  @if (!pdfDownloading[row.uploadedDocumentId]) {
                    <i class="fas fa-download clickable" (click)="downloadFile(row.uploadedDocumentId,row.displayName,row.uploadedFileLink)"></i>
                  }
                  @if (pdfDownloading[row.uploadedDocumentId]) {
                    <span><i class="fas fa-circle-notch fa-spin"></i></span>
                  }
                  @if (isPDF(row.displayName) ||  type === 'all') {
                    <span>
                      @if (!pdfLoading[row.uploadedDocumentId]) {
                        <i class="ms-3 fas fa-eye clickable" (click)="viewFile(row.uploadedDocumentId,row.uploadedFileLink)"></i>
                      }
                      @if (pdfLoading[row.uploadedDocumentId]) {
                        <span><i class="ms-3 fas fa-circle-notch fa-spin"></i></span>
                      }
                    </span>
                  }
                </td>
                <td>
                  <span [matTooltip]="getTooltipContent(row)" matTooltipPosition="above" positionAtOrigin="true">
                    @if (getFileStatusObject(row)) {
                      <i [ngClass]="getFileStatusObject(row)?.icon" (click)="searchRecord()" class="ms-3 clickable"></i>
                    }
                    @if (!getFileStatusObject(row)) {
                      <span class="text-muted ms-3">—</span>
                    }
                  </span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <mat-paginator [length]="pagination.total" [pageSize]="pagination.limit"
        [pageSizeOptions]="[5, 10, 15, 25, 100, 3000]" (page)="pageChange($event)">
      </mat-paginator>
    </div>
  </div>
</div>